import { useState, useMemo } from "react";

function DPDropdown({ dpIdList, CLTDPID }) {
  const [open, setOpen] = useState(false);

  // ✅ Get unique dpIds (preserve order)
  const uniqueDpIds = useMemo(() => {
    const seen = new Set();
    return dpIdList.filter(item => {
      if (seen.has(item.dpId)) return false;
      seen.add(item.dpId);
      return true;
    });
  }, [dpIdList]);

  // Case 3: If dpIdList is empty → show CLTDPID
  if (!uniqueDpIds || uniqueDpIds.length === 0) {
    return <span className="dp-single">{CLTDPID}</span>;
  }

  // Case 2: If only one dpId → show it directly
  if (uniqueDpIds.length === 1) {
    return <span className="dp-single">{uniqueDpIds[0].dpId}</span>;
  }

  // Case 1: Multiple dpIds → show dropdown
  return (
    <div className="dp-dropdown-wrapper">
      <div className="dp-selected" onClick={() => setOpen(!open)}>
        {uniqueDpIds[0].dpId}
        <span className={`arrow ${open ? "up" : ""}`} />
      </div>

      {open && (
        <ul className="dp-dropdown-list">
          {uniqueDpIds.slice(1).map((item, index) => (
            <li key={index} className="dp-dropdown-item">
              {item.dpId}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default DPDropdown;
